// extracted by mini-css-extract-plugin
module.exports = {"LightBoxHeader":"LightBoxHeader__LightBoxHeader__3Hf0D","icon":"LightBoxHeader__icon__3vypH"};